module.exports = __webpack_public_path__ + "media/images/horizontal_right_image-81143688be6cfec8bf2f4c4d1172b50e.png";